/**
 * Formats a byte count into a human-readable size string (e.g. `2 MB`).
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;

  const kb = bytes / 1024;
  if (kb < 1024) return `${Math.round(kb)} KB`;

  const mb = kb / 1024;
  return `${mb >= 10 ? Math.round(mb) : Number(mb.toFixed(1))} MB`;
};
